import React, { useState } from "react";
import styles from "./TransporterTable.module.css";
import LaneRow from "./LaneRow";
import axios from "../../../../../../Axios";
import { Urls } from "../../../../../../Urls";
import { toast } from "react-toastify";

const TransporterTable = ({
  lanes,
  createMultipleIndents,
  setshow,
  setStep,
  setValidationErrors,
}) => {
  const [globalSelection, setGlobalSelection] = useState("uploaded");
  const [overrideSelection, setOverrideSelection] = useState({});
  const [showModal, setShowModal] = useState(false);

  const getLaneKey = (lane) =>
    lane.freight_id ||
    `${lane.origin.location_name}-${lane.destination.location_name}-${lane.truck_type.value}`;

  const handleGlobalChange = (selection) => {
    setGlobalSelection(selection);
    const newOverrides = {};
    lanes.forEach((lane) => {
      if (selection === "fm" && lane.fm_transporter.length === 0) {
        newOverrides[getLaneKey(lane)] = "uploaded";
      } else {
        newOverrides[getLaneKey(lane)] = selection;
      }
    });
    setOverrideSelection(newOverrides);
  };

  const handleSave = () => {
    setShowModal(true);
  };
  const handleModalChoice = (choice) => {
    setShowModal(false);
    setshow(false);
    const indentPayload = [];
    let existingLanesInFM = [];
    let nonExistingLanesInFM = [];

    lanes.forEach((lane) => {
      const laneKey = getLaneKey(lane);
      const selection = overrideSelection[laneKey] || globalSelection;

      const selectedTransporters =
        selection === "uploaded"
          ? lane.shortlisted_transporters
          : lane.fm_transporter;
      indentPayload.push({
        origin: lane.origin,
        destination: lane.destination,
        truck_types: [lane.truck_type],
        transporter_details: selectedTransporters,
        $date: lane?.placement_date ?? new Date(),
        truck_required: lane?.volume ?? 0,
      });
      const transporter_details = (selectedTransporters || []).map((t) => ({
        rank: t.rank ?? "",
        rate: t.rate ?? 0,
        business_share: t.business_share ?? 0,
        transporter: {
          transporter_id: t.transporter_id ?? "",
          logo: t.logo ?? "",
          transporter_name: t.transporter_name ?? "",
          contact_information: t.contact_information ?? [],
          percentage_completion: t.percentage_completion ?? 0,
          overall_rating: t.overall_rating ?? 0,
          number_of_ratings: t.number_of_ratings ?? 0,
          access_control: t.access_control ?? [],
        },
        total_truck_allocation: null,
      }));

      const fmLane = {
        origin: {
          ...lane.origin,
          location_type: lane.origin?.location_type ?? "Destination",
        },
        destination: lane.destination,
        truck_type: lane.truck_type,
        volume: lane.volume ?? 0,
        transit_time: 0,
        baseline_rate: null,
        market_rate: null,
        site_rate: null,
        challenge_price: null,
        unit: "MT",
        zone: "",
        route_code: "",
        contract_tenure: "",
        truck_load: "",
        transporter_details,
      };

      if (lane.exists === "yes") {
        existingLanesInFM.push(fmLane);
      } else {
        nonExistingLanesInFM.push(fmLane);
      }
    });
    if (choice === "yes") {
      createMultipleIndents(indentPayload);
      setStep(1);
      setValidationErrors();
      // .then(() => {
      if (nonExistingLanesInFM && nonExistingLanesInFM.length > 0) {
        // freightAPIs.push(
        axios.post(`${Urls.freight_master}?action=create_freight_master`, {
          excel_id: localStorage.getItem("fm_excel_id") ?? "",
          lanes: nonExistingLanesInFM,
        });
        // );
      }
      if (existingLanesInFM && existingLanesInFM.length > 0) {
        // freightAPIs.push(
        axios.put(`${Urls.freight_master}?action=edit_freight_master`, {
          lanes: existingLanesInFM,
        });
        // );
      }
      toast.success("Lanes saved in Freight Master");
      // return Promise.all(freightAPIs);
      // })
      // .then(() => {
      // toast.success("Lanes saved in Freight Master");
      // })
      // .catch((err) => {
      // console.error(err, "error");
      // });
    } else if (choice === "no") {
      createMultipleIndents(indentPayload);
      setStep(1);
      setValidationErrors();
    } else if (choice === "cancel") {
      setShowModal(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerBar}>
        <div className={styles.headerTitle}>Lane & Transporter Selection</div>
        <div className={styles.globalActions}>
          <label
            style={{
              fontSize: "13px",
              display: "flex",
              alignItems: "center",
              gap: "3px",
            }}
          >
            <input
              type="radio"
              name="globalSelect"
              checked={globalSelection === "uploaded"}
              onChange={() => handleGlobalChange("uploaded")}
            />{" "}
            Select All Uploaded Transporters
          </label>
          <label
            style={{
              fontSize: "13px",
              display: "flex",
              alignItems: "end",
              gap: "3px",
            }}
          >
            <input
              type="radio"
              name="globalSelect"
              checked={globalSelection === "fm"}
              onChange={() => handleGlobalChange("fm")}
            />{" "}
            Select All Freight Master Transporters
          </label>
        </div>
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Lane</th>
            <th>Uploaded Transporters</th>
            <th>Freight Master Transporters</th>
          </tr>
        </thead>
        <tbody>
          {lanes.map((lane, index) => (
            <LaneRow
              index={index}
              lane={lane}
              overrideSelection={overrideSelection}
              setOverrideSelection={setOverrideSelection}
              globalSelection={globalSelection}
            />
          ))}
        </tbody>
      </table>

      <button className={styles.saveButton} onClick={handleSave}>
        Create Indents
      </button>

      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <button
              className={styles.modalClose}
              onClick={() => handleModalChoice("cancel")}
            >
              ×
            </button>

            <div className={styles.modalContent}>
              <h4>Would you like to save the lanes in Freight Master?</h4>
            </div>

            <div className={styles.modalActions}>
              <button onClick={() => handleModalChoice("yes")}>Yes</button>
              <button onClick={() => handleModalChoice("no")}>No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransporterTable;
